import { render, staticRenderFns } from "./ClassWallet.vue?vue&type=template&id=38137d93&scoped=true"
import script from "./ClassWallet.vue?vue&type=script&lang=js"
export * from "./ClassWallet.vue?vue&type=script&lang=js"
import style0 from "./ClassWallet.vue?vue&type=style&index=0&id=38137d93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38137d93",
  null
  
)

export default component.exports